import React from "react";
import PropTypes from "prop-types";
import Dropzone from "react-dropzone";
import request from "superagent";
import { defineMessages, FormattedMessage } from "react-intl";
import cx from "classnames";

import Base from "../Base";
import Icon from "../../../Icon/Icon";
import Image from "../../../Image";

const messages = defineMessages({
  processing: {
    id: "form.file.processing",
    defaultMessage: "processing..."
  },
  uploadAvatar: {
    id: "form.file.uploadAvatar",
    defaultMessage: "Upload Avatar"
  }
});

class Avatar extends Base {
  static propTypes = {
    ...Base.propTypes,
    uploadPath: PropTypes.string.isRequired,
    filePath: PropTypes.string.isRequired,
    accept: PropTypes.string.isRequired,
    minSize: PropTypes.number,
    maxSize: PropTypes.number
  };

  static defaultProps = {
    ...Base.defaultProps,
    accept: "image/*",
    minSize: 0,
    maxSize: 1024 * 1000 * 1000
  };

  constructor(...args) {
    super(...args);
    this.onDownloadClick = this.onDownloadClick.bind(this);
    this.onItemDelete = this.onItemDelete.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }

  isValid(value, checkErrors = true) {
    let isValid = true;
    const errors = [];
    if (
      this.props.required &&
      (value === "" ||
        value == null ||
        value.media == null ||
        value.media._id === "")
    ) {
      errors.push({ type: "required", text: this.props.requiredErrorText });
      isValid = false;
    }

    if (checkErrors) {
      this.setState({ errors });
    }
    return isValid;
  }

  getValue(applyFilters) {
    const value =
      this.state.value && this.state.value.media && this.state.value.media._id
        ? {
            media: {
              _id: this.state.value.media._id,
              ext: this.state.value.media.ext
            },
            focalSelector: this.state.value.focalSelector
          }
        : null;
    return applyFilters ? this.applyFilters(value) : value;
  }

  onDrop(acceptedFiles, rejectedFiles, e) {
    if (rejectedFiles.length > 0) {
      console.error(rejectedFiles, e);
      this.setState({ uploadError: true });
    }
    if (acceptedFiles.length > 0) {
      this.setState({
        isUploading: true,
        transferDirection: "upload",
        uploadPercent: 0
      });
      const req = request.post(this.props.uploadPath);
      acceptedFiles.forEach(file => {
        req.attach("myfiles", file, file.name);
      });
      req
        .on("progress", event => {
          this.setState({
            transferDirection: event.direction,
            uploadPercent: event.percent
          });
        })
        .end((err, res) => {
          this.setState({ isUploading: false });
          if (res.body instanceof Object) {
            this.onChange({
              target: {
                value: {
                  media: { _id: res.body._id, ext: res.body.ext },
                  focalSelector: ""
                }
              }
            });
          }
        });
    }
  }

  onDownloadClick() {
    window.open(`${this.props.filePath}/${this.state.value.media._id}`);
  }

  onItemDelete(e) {
    this.onChange({ target: { value: null } });
  }

  render() {
    const { isUploading, transferDirection, uploadPercent, value } = this.state;
    const inputID = this.getInputID();

    let dropzoneContent;
    if (
      isUploading &&
      transferDirection === "upload" &&
      uploadPercent !== 100
    ) {
      dropzoneContent = (
        <div className="Avatar__dropzoneText">{uploadPercent.toFixed(1)}%</div>
      );
    } else if (isUploading) {
      dropzoneContent = (
        <div className="Avatar__dropzoneText">
          <FormattedMessage {...messages.processing} />
        </div>
      );
    } else {
      dropzoneContent = (
        <div className="Avatar__dropzoneText --isLink">
          <FormattedMessage {...messages.uploadAvatar} />
        </div>
      );
    }

    console.log(this.props.filePath);

    return (
      <div className="Avatar" id={inputID}>
        <div className="Avatar__container">
          {((value || {}).media || {})._id ? (
            <div className="Avatar__imageContainer">
              <Image
                className="Avatar__image"
                src={`${this.props.filePath}/${value.media._id}?width=125&height=125&type=fit`}
              />
              <div className="Avatar__controls">
                <button
                  className="Avatar__button"
                  type="button"
                  onClick={this.onDownloadClick}
                >
                  <Icon icon="arrowDownToLine" />
                </button>
                <button
                  className="Avatar__button"
                  type="button"
                  onClick={this.onItemDelete}
                >
                  <Icon icon="trash" />
                </button>
              </div>
            </div>
          ) : (
            <Dropzone
              ref={node => {
                this.dropzone = node;
              }}
              className="Avatar__dropzone"
              disableClick={false}
              accept={this.props.accept}
              multiple={false}
              minSize={this.props.minSize}
              maxSize={this.props.maxSize}
              onDrop={this.onDrop}
            >
              <div
                className={cx("Avatar__dropzoneIcon", {
                  "--isUploading": isUploading
                })}
              >
                {!isUploading && <Icon icon="user" />}
              </div>
              {dropzoneContent}
            </Dropzone>
          )}
        </div>
      </div>
    );
  }
}

export default Avatar;



// WEBPACK FOOTER //
// ./src/components/Form/Input/Avatar/Avatar.js